// extracted by mini-css-extract-plugin
export var errorIcon = "_qe-1";
export var nameLogo = "_qe-0";